import ASLogo from "../graphics/ASLogo";
import SystemBrand from "../graphics/SystemBrand";

const HeaderStandard = () => {
  return (
    <header className="navbar px-4">
      <a className="navbar-brand text-white" href="/">
        <SystemBrand />
      </a>
      <a
        className="navbar-brand text-white text-end"
        target="_blank"
        rel="noreferrer"
        href="https://www.advokatsamfundet.dk/"
      >
        <ASLogo height={58} />
      </a>
    </header>
  );
};

export default HeaderStandard;
